import { AUTH_URL } from "./utils";

const setToken = (token, dataToken) => {
  localStorage.setItem("login_token", token);
  localStorage.setItem("data_token", JSON.stringify(dataToken));
};

const signUp = (data) => {
  return fetch(AUTH_URL + "register", {
    method: "POST",
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

const signIn = (data) => {
  return fetch(AUTH_URL + "login", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

const profile = (token) => {
  return fetch(AUTH_URL + "profile", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const confirmUser = (code) => {
  return fetch(AUTH_URL + "confirm/" + code);
};

const AuthService = {
  setToken,
  signUp,
  signIn,
  profile,
  confirmUser
};

export default AuthService;
